export const postComponentInfo = componentName => {
  if (window.top !== window) {
    window.parent.postMessage({ component: componentName }, '*');
  }
};



// WEBPACK FOOTER //
// ./src/lib/iframe-messages.js